import { Statistic } from 'antd';
import { useMemo } from 'react';
import { DefaultTheme, useTheme } from 'styled-components';

import { Wrapper } from './QuizTimer.styles';

import { Icon } from '@/components/Icon';
import { useCountdown } from '@/hooks';

const { Countdown } = Statistic;

export const QuizTimer: React.FC = () => {
  const { colors } = useTheme();
  const {
    countdown,
    remainingTime,
    isPaused,
    toggle,
    setRemainingTime,
    isFinished,
    setIsFinished
  } = useCountdown();
  const { minutes, seconds } = useMemo(() => {
    if (!remainingTime || isFinished) return { minutes: 0, seconds: 0 };

    const totalSeconds = Math.floor(remainingTime / 1000);
    const min = Math.floor((totalSeconds % 3600) / 60);
    const sec = totalSeconds % 60;

    return { minutes: min, seconds: sec };
  }, [remainingTime, isFinished]);

  const { color, colorKey }: { color: string; colorKey: keyof DefaultTheme['colors'] } =
    useMemo(() => {
      if (minutes === 0 && seconds <= 10) {
        return { color: colors.red7, colorKey: 'red7' };
      }

      if (minutes <= 1 && seconds >= 0) {
        return { color: colors.orange7, colorKey: 'orange7' };
      }

      return { color: colors.black9, colorKey: 'black9' };
    }, [minutes, seconds, colors]);

  return (
    <Wrapper color={color}>
      <Icon i="Time" color={colorKey} />
      {isPaused ? (
        <div>{`${minutes < 10 ? `0${minutes}` : minutes}:${
          seconds < 10 ? `0${seconds}` : seconds
        }`}</div>
      ) : (
        <Countdown
          value={countdown}
          onChange={v => setRemainingTime(Number(v))}
          onFinish={() => {
            setIsFinished(true);
            toggle();
          }}
          format="mm:ss"
        />
      )}
    </Wrapper>
  );
};
